import { useLingui } from "@lingui/react/macro";
import { useMaterialUsage } from "@/hooks/recipes";
import { RecipeUsageListing } from "@/components/recipes/usage/RecipeUsageListing";

/** Every recipe that uses this ingredient, how much, and what that costs there. */
export function UsedInRecipesTab({ materialId }: { materialId: number }) {
  const { t } = useLingui();
  const { data, isLoading, isError, refetch } = useMaterialUsage(materialId);

  return (
    <div className="px-6">
      <RecipeUsageListing
        lines={data}
        isLoading={isLoading}
        isError={isError}
        onRetry={() => void refetch()}
        emptyMessage={t`No recipe uses this ingredient yet.`}
      />
    </div>
  );
}
